<template>
    <!-- Sidebar -->
    <div class="offcanvas offcanvas-end" tabindex="-1" id="offcanvasRight" aria-labelledby="offcanvasRightLabel">
        <div class="offcanvas-header border-b-1-solid">
            <div class="titulo-filtros d-flex align-items-center pb-2">
                <img src="/img/icono-filtro-mob.svg" alt="Ícono de filtros" class="me-2 d-none d-md-block" width="30">
                <img src="/img/icono-filtro-mob-hover.svg" alt="Ícono de filtros" class="ms-3 me-2 d-md-none" width="30">
                <h6 class="mb-0 fs-5 fw-600">Filtros</h6>
            </div>
            <button type="button" @click="$emit('sidebar-closed')" class="btn-close btn-close-white d-md-none" data-bs-dismiss="offcanvas" aria-label="Close"></button>
            <button type="button" @click="$emit('sidebar-closed')" class="btn-close d-none d-md-block" data-bs-dismiss="offcanvas" aria-label="Close"></button>
        </div>
        <div class="offcanvas-body">
            <form class="sidebar-filtros" @reset.prevent="resetForm">
                <div class="accordion accordion-flush" id="accordionPanelsStayOpenExample">
                    <div class="accordion-item">
                        <h2 class="accordion-header" id="panelsStayOpen-headingOne">
                            <button class="accordion-button fw-600" type="button" data-bs-toggle="collapse"
                                data-bs-target="#panelsStayOpen-collapseOne" aria-expanded="true"
                                aria-controls="panelsStayOpen-collapseOne">
                                Categoría
                            </button>
                        </h2>
                        <div id="panelsStayOpen-collapseOne" class="accordion-collapse collapse show"
                            aria-labelledby="panelsStayOpen-headingOne">
                            <div class="accordion-body py-2">
                                <RadioCheckbox
                                    v-for="category in categories"
                                    :key="category.id"
                                    :label="category.name"
                                    :inputValue="category.id"
                                    v-model="filters.categories"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="accordion-item">
                        <h2 class="accordion-header" id="panelsStayOpen-headingTwo">
                            <button class="accordion-button fw-600" type="button" data-bs-toggle="collapse"
                                data-bs-target="#panelsStayOpen-collapseTwo" aria-expanded="true"
                                aria-controls="panelsStayOpen-collapseTwo">
                                Tipo
                            </button>
                        </h2>
                        <div id="panelsStayOpen-collapseTwo" class="accordion-collapse collapse show"
                            aria-labelledby="panelsStayOpen-headingTwo">
                            <div class="accordion-body py-2">
                                <RadioCheckbox
                                    :label="'Portadas'"
                                    :inputValue="'coverImage'"
                                    v-model="filters.types"
                                />
                                <RadioCheckbox
                                    :label="'Imágenes'"
                                    :inputValue="'images'"
                                    v-model="filters.types"
                                />
                                <RadioCheckbox
                                    :label="'Videos'"
                                    :inputValue="'videos'"
                                    v-model="filters.types"
                                />
                                <RadioCheckbox
                                    :label="'Redes Sociales'"
                                    :inputValue="'socialMedia'"
                                    v-model="filters.types"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="accordion-item">
                        <h2 class="accordion-header" id="panelsStayOpen-headingFive">
                            <button class="accordion-button fw-600" type="button" data-bs-toggle="collapse"
                                data-bs-target="#panelsStayOpen-collapseFive" aria-expanded="true"
                                aria-controls="panelsStayOpen-collapseFive">
                                Orientación
                            </button>
                        </h2>
                        <div id="panelsStayOpen-collapseFive" class="accordion-collapse collapse show"
                            aria-labelledby="panelsStayOpen-headingFive">
                            <div class="accordion-body py-2">
                                <RadioCheckbox
                                    :label="'Vertical'"
                                    :inputValue="'portrait'"
                                    v-model="filters.orientations"
                                />
                                <RadioCheckbox
                                    :label="'Horizontal'"
                                    :inputValue="'landscape'"
                                    v-model="filters.orientations"
                                />
                                <RadioCheckbox
                                    :label="'Cuadrada'"
                                    :inputValue="'square'"
                                    v-model="filters.orientations"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="accordion-item">
                        <h2 class="accordion-header" id="panelsStayOpen-headingThree">
                            <button class="accordion-button fw-600" type="button" data-bs-toggle="collapse"
                                data-bs-target="#panelsStayOpen-collapseThree" aria-expanded="true"
                                aria-controls="panelsStayOpen-collapseThree">
                                Fecha de Publicación
                            </button>
                        </h2>
                        <div id="panelsStayOpen-collapseThree" class="accordion-collapse collapse show"
                            aria-labelledby="panelsStayOpen-headingThree">
                            <div class="accordion-body py-2">
                                <div class="container-fluid my-3">
                                    <div class="row">
                                        <div class="col-6 pe-1">
                                            <input
                                                class="w-100 py-2 py-md-1"
                                                type="text"
                                                placeholder="Desde"
                                                onfocus="(this.type='date')"
                                                onblur="(this.type='text')"
                                                v-model="filters.dates.from"
                                            />
                                        </div>
                                        <div class="col-6 ps-1">
                                            <input
                                                class="w-100 py-2 py-md-1"
                                                type="text"
                                                placeholder="Hasta"
                                                onfocus="(this.type='date')"
                                                onblur="(this.type='text')"
                                                v-model="filters.dates.to"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="accordion-item">
                        <h2 class="accordion-header" id="panelsStayOpen-headingFour">
                            <button class="accordion-button fw-600" type="button" data-bs-toggle="collapse"
                                data-bs-target="#panelsStayOpen-collapseFour" aria-expanded="true"
                                aria-controls="panelsStayOpen-collapseFour">
                                Tags frecuentes
                            </button>
                        </h2>
                        <div id="panelsStayOpen-collapseFour" class="accordion-collapse collapse show"
                            aria-labelledby="panelsStayOpen-headingFour">
                            <div class="accordion-body py-2">
                                <TagCheckbox
                                    v-for="tag in tags"
                                    :key="tag.id"
                                    :label="tag.name"
                                    :inputValue="tag.id"
                                    v-model="filters.tags"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="container">
                        <div class="row justify-content-center pt-4 pb-5">
                            <div class="col-6 col-md-5 p-1">
                                <input type="reset" class="btn btn-renault-secondary fs-08 w-100" value="Borrar Todo">
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import RadioCheckbox from "./RadioCheckbox.vue";
import TagCheckbox from "./TagCheckbox.vue";
export default {
    components: { TagCheckbox, RadioCheckbox },
    data() {
        return {
            filters: {
                tags: [],
                categories: [],
                types: [],
                orientations: [],
                dates: {
                    from: "",
                    to: "",
                },
            },
        };
    },
    props: {
        initialFilters: Object,
        tags: Array,
        categories: Array,
    },
    mounted() {
    },
    emits: ["sidebar-closed", "filtered"],
    watch: {
        filters: {
            handler(newValue, oldValue) {
                this.$emit("filtered", newValue);
            },
            deep: true,
        },
    },
    methods: {
        resetForm(e) {
            this.filters.tags = [];
            this.filters.categories = [];
            this.filters.types = [];
            this.filters.orientations = [];
            this.filters.dates.from = "";
            this.filters.dates.to = "";
        }
    }
};
</script>
